import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import constants from "../../../../config/constants";
import TextField from "@mui/material/TextField/TextField";
import Button from "@mui/material/Button";
import "../anniv2025.css";
import "../../../utils/auth/auth.css";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

export const Login = ({setUser, setPasswordOutput}) => {

    const mobile = window.innerWidth < 700;
    const [username, setUsername] = useState(localStorage.getItem("anniv2025-username") || "");
    const [password, setPassword] = useState(localStorage.getItem("anniv2025-password") || "");
    const [error, setError] = useState("");
    const [isLogin, setIsLogin] = useState(false);
    const [displayLogin, setDisplayLogin] = useState(false);
    const setters = {
        email: setUsername,
        password: setPassword
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
        setOpacityMenu(true);
    };
    const handleCloseMenu = () => {
        setOpacityMenu(false);
        setTimeout(() => {
            setAnchorEl(null);
        }, 300);
    };
    const [opacityMenu, setOpacityMenu] = useState(false);

    function selectUser(user) {
        handleCloseMenu();
        setUsername(user);
    }

    const users = [
        "Amandine",
        "Anna",
        "Aurore",
        "Bagounet",
        "Bassoot",
        "Bulon	",
        "Canardwcbang",
        "Céline",
        "Champion",
        "Charles",
        "Charlotte",
        "Claire",
        "Coco	",
        "Croustigrou",
        "Des Bois",
        "Dondridri",
        "Erzangel",
        "Eva",
        "Flo",
        "Lamymag",
        "LaPioche",
        "Loùle",
        "Marius",
        "Minthe",
        "Muaddib",
        "Navet",
        "Nibi",
        "Odylea",
        "Ronflex",
        "Schnapps",
        "Sergent",
        "Sousou",
        "Titi",
        "Totor",
        "Victor",
        "Welcome",
    ]

    const initialLogin = useRef(false);

    useEffect(() => {
        if (!initialLogin.current) {
            if (username && password) {
                login();
            } else {
                setDisplayLogin(true);
            }
            initialLogin.current = true;
        }
    }, []);

    function login() {
        if (username && password && !isLogin) {
            setError(false);
            axios.post(constants.api.basePath + "/anniv2025/login", {username, password}).then(res => {
                setIsLogin(true);
                setUser(res.data.user);
                setPasswordOutput(password);
                localStorage.setItem("anniv2025-username", username);
                localStorage.setItem("anniv2025-password", password);
            }).catch(err => {
                console.log(err);
                setError("Invalide");
                setDisplayLogin(true);
            });
        }
    }

    if (!displayLogin) {
        return undefined;
    }

    return (
        <div className="auth-form">
            <h2>Première connexion</h2>
            <form name="form" onSubmit={(e) => {
                e.preventDefault();
                // Handle login logic here
            }}>
                <div className={"form-group"}>
                    <label htmlFor="email">Invité</label><br/>
                    {
                        username ?
                            <div>
                                {username} <Button variant={"contained"} onClick={() => setUsername("")}>X</Button>
                            </div> :
                            <div style={{position: "relative"}}>
                                <Button
                                    variant={"contained"}
                                    id={"button-user"} onClick={handleOpenMenu}>
                                    Sélectionner
                                </Button>
                                {
                                    open ?
                                        <div style={{
                                            position: "absolute",
                                            top: 0,
                                            right: 0,
                                            height: "60vh",
                                            background: "#1f2136",
                                            overflowY: "scroll",
                                            opacity: opacityMenu ? 1 : 0,
                                            transition: "opacity 355ms cubic-bezier(0.4, 0, 0.2, 1), transform 236ms cubic-bezier(0.4, 0, 0.2, 1)",
                                            boxShadow: "0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)",
                                            borderRadius: "4px",
                                            zIndex: 250
                                        }}>
                                            {
                                                users.map(user =>
                                                    <MenuItem key={user} onClick={() => selectUser(user)}>
                                                        {user}
                                                    </MenuItem>
                                                )
                                            }
                                        </div> : undefined
                                }
                            </div>
                    }
                </div>
                <div className={"form-group"}>
                    <label htmlFor="password">Mot de passe</label><br/>
                    <TextField
                        type="password"
                        placeholder="Mot de passe"
                        variant="outlined"
                        hiddenLabel
                        style={mobile ? {width: "100%"} : {}}
                        size="small"
                        value={password}
                        onChange={(e) => setters.password(e.target.value)}
                        required
                    />
                </div>
                <div style={{textAlign: "center", marginTop: "3vh"}}>
                    <Button variant="contained" type="submit" onClick={() => login()}>
                        Se connecter
                    </Button>
                </div>
            </form>
            {error && <p style={{color: 'red'}}>{error}</p>}
        </div>
    )

}
